/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const Currency = {
    Usd: 'USD',
    Mxn: 'MXN'
} as const;
export type Currency = typeof Currency[keyof typeof Currency];

